<template>
  <div>
    <el-card class="control-panel_card">
      <div slot="header" class="clearfix">
        <span>统计数据</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="handleRefresh">刷新</el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="getIsMobile?24:3">
          <el-statistic :value="statisticalData.newm_c" title="今日新增客户" />
        </el-col>
        <el-col :span="getIsMobile?24:3">
          <el-statistic :value="statisticalData.quote_c" title="今日报价" />
        </el-col>
        <el-col :span="getIsMobile?24:3">
          <el-statistic :value="statisticalData.price_m" title="当月成交额" />
        </el-col>
        <el-col :span="getIsMobile?24:3">
          <el-statistic :value="statisticalData.fukuan_m" title="当月到账额" />
        </el-col>
        <el-col :span="getIsMobile?24:3">
          <el-statistic :value="statisticalData.arrears_m" title="客户总欠款" />
        </el-col>
        <el-col :span="getIsMobile?24:3">
          <el-statistic :value="statisticalData.price_d" title="今日成交额" />
        </el-col>
        <el-col :span="getIsMobile?24:3">
          <el-statistic :value="statisticalData.fukuan_d" title="今日到账额" />
        </el-col>
      </el-row>
    </el-card>
    <el-card class="control-panel_card">
      <div ref="chartRef" style="width: 100%; height: 400px;"></div>
    </el-card>
  </div>
</template>

<script>
import echarts from 'echarts'
import request from '@/utils/request'
import { ref, onMounted, defineComponent, reactive, nextTick } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
export default defineComponent({
  name: 'ControlPanel',
  setup() {
    const {getIsMobile} = useRootSetting()
    const chartRef = ref(null)
    let chartInstance = null
    const statisticalData = reactive({
      arrears_m: '',
      fukuan_d: '',
      fukuan_m: '',
      newm_c: '',
      price_d: '',
      price_m: '',
      quote_c: '',
      echartsData: {}
    })

    //获取统计数据
    const getStatisticalData = async () => {
      const data = await request({
        url: 'control_panel.yy',
        method: 'post'
      }).then((res) => {
        const { data: { arrears_m, fukuan_d, fukuan_m, newm_c, price_d, price_m, quote_c, every_m } } = res;
        [statisticalData.arrears_m, statisticalData.fukuan_d, statisticalData.fukuan_m, statisticalData.newm_c, statisticalData.price_d, statisticalData.price_m, statisticalData.quote_c, statisticalData.echartsData] = [arrears_m, fukuan_d, fukuan_m, newm_c, price_d, price_m, quote_c, every_m]
        chartInstance.setOption({
          title: {
            text: '每月成交金额'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            top: '5%',
            data: statisticalData.echartsData.series.map(item => item.name) // 图例
          },
          xAxis: {
            data: statisticalData.echartsData.xAxis.map(item => item + '月') // 示例：横轴数据
          },
          yAxis: { type: 'value'},
          color: ['#4CAF50', '#2196F3'],
          series: statisticalData.echartsData.series.map(item => ({
            name: item.name,
            type: 'bar',
            data: item.data,
            barWidth: '30%'
          }))
        })
      })

      // 监听窗口大小变化，保持图表自适应
      window.addEventListener('resize', () => {
        chartInstance.resize()
      })
    }

    onMounted(() => {
      nextTick(async () => {
        if (chartRef.value) {
          chartInstance = echarts.init(chartRef.value) // 现在 chartRef.value 一定存在
          await getStatisticalData()
        }
      })
    })
   // 刷新
    const handleRefresh = () => {
      getStatisticalData()
    }

    return {
      getIsMobile,
      statisticalData,
      chartRef,
      handleRefresh
    }
  }
})
</script>
<style lang="scss">
.control-panel_card {
  margin: 20px;
  padding-bottom: 20px;
}
</style>
